<template>
  <div class="d-flex align-center pt-3 pb-2 px-3">
    <span class="font-20 font-weight-medium text-systock-blue">Status Produto</span>

    <v-divider vertical class="mx-4" />

    <Filtros :size="2" @update:filtros="aplicarFiltros()">
      <template #append>
        <DivisorComLegenda legenda="Outros filtros" class="mt-3" />

        <div class="d-flex align-center mt-3">
          <div class="w-33-porcento pr-1">
            <SysCompradorAutocomplete
              v-model="FILTROS_COMPUTED.compradores"
              label="Compradores"
              :qtde_visivel_selecionados="1"
              outlined
              clearable
              multiple
              hide-details
            />
          </div>

          <div class="w-33-porcento px-1">
            <SysSegmentoAutocomplete
              v-model="FILTROS_COMPUTED.segmentos"
              label="Segmentos"
              :qtde-visivel-selecionados="1"
              outlined
              clearable
              multiple
              hide-details
            />
          </div>

          <div class="w-33-porcento pl-1">
            <SysFornecedorAutocomplete
              v-model="FILTROS_COMPUTED.fornecedores"
              label="Fornecedores"
              :qtde-visivel-selecionados="1"
              outlined
              clearable
              multiple
              hide-details
            />
          </div>
        </div>

        <div class="d-flex align-center mt-3">
          <div class="w-33-porcento pr-1">
            <v-select
              v-model="FILTROS_COMPUTED.classificacao_financeira"
              :items="SELECTS_COMPUTED.classificacao_financeira"
              outlined
              clearable
              multiple
              item-text="text"
              item-value="value"
              label="ABC de Custo"
              hide-details
            />
          </div>

          <div class="w-33-porcento px-1">
            <v-select
              v-model="FILTROS_COMPUTED.classificacao_criticidade"
              :items="SELECTS_COMPUTED.classificacao_criticidade"
              outlined
              clearable
              multiple
              item-text="text"
              item-value="value"
              label="ABC de Faturamento"
              hide-details
            />
          </div>

          <div class="w-33-porcento pl-1">
            <v-select
              v-model="FILTROS_COMPUTED.classificacao_rentabilidade"
              :items="SELECTS_COMPUTED.classificacao_rentabilidade"
              outlined
              clearable
              multiple
              item-text="text"
              item-value="value"
              label="ABC de Rentabilidade"
              hide-details
            />
          </div>
        </div>

        <div class="d-flex align-center mt-3">
          <div class="w-33-porcento pr-1">
            <v-select
              v-model="FILTROS_COMPUTED.classificacao_comprabilidade"
              :items="SELECTS_COMPUTED.classificacao_comprabilidade"
              outlined
              clearable
              multiple
              item-text="text"
              item-value="value"
              label="Classificação de Comprabilidade"
              hide-details
            />
          </div>

          <div class="w-33-porcento px-1">
            <v-select
              v-model="FILTROS_COMPUTED.classificacao_popularidade"
              :items="SELECTS_COMPUTED.classificacao_popularidade"
              outlined
              clearable
              multiple
              item-text="text"
              item-value="value"
              label="Frequência de Saída"
              hide-details
            />
          </div>

          <div class="w-33-porcento ml-1" />
        </div>
      </template>
    </Filtros>
  </div>
</template>

<script>
import Filtros from '@/components/Diagnostico/utils/Filtros.vue';
import SysGrupoAutocomplete from '../../../utils/crud/SysGrupoAutocomplete.vue';
import SysSegmentoAutocomplete from '../../../utils/crud/SysSegmentoAutocomplete.vue';
import SysFornecedorAutocomplete from '../../../utils/crud/SysFornecedorAutocomplete.vue';
import SysCompradorAutocomplete from '../../../utils/crud/SysCompradorAutocomplete.vue';
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  components: {
    DivisorComLegenda,
    Filtros,
    SysGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete
  },
  props: ['filtros'],
  model: {
    prop: 'filtros',
    event: 'chenge-filtros'
  },
  data: () => ({
    abc_criticidade: [
      { text: 'A - Faturamento Elevado', value: 'A' },
      { text: 'B - Faturamento Médio', value: 'B' },
      { text: 'C - Faturamento Baixo', value: 'C' },
    ],
    abc_financeira: [
      { text: 'A - Custo Elevado', value: 'A' },
      { text: 'B - Custo Médio', value: 'B' },
      { text: 'C - Custo Baixo', value: 'C' },
    ],
    abc_rentabilidade: [
      { text: 'A - Rentabilidade Elevada', value: 'A' },
      { text: 'B - Rentabilidade Média', value: 'B' },
      { text: 'C - Rentabilidade Baixa', value: 'C' },
    ],
    abc_popularidade: [
      { text: '1. Frequência Alta de Saída', value: 'A' },
      { text: '2. Frequência Média de Saída', value: 'B' },
      { text: '3. Frequência Baixa de Saída', value: 'C' },
    ],
    abc_comprabilidade: [
      { text: '1. Comprabilidade Complexa', value: 'A' },
      { text: '2. Comprabilidade Difícil', value: 'B' },
      { text: '3. Comprabilidade Previsível', value: 'C' },
    ],
    timer_mudar_grupos: null
  }),
  computed: {
    FILTROS_COMPUTED: {
      get() { return this.filtros },
      set(valor) { this.$emit('change-filtros', valor) }
    },
    SELECTS_COMPUTED() {
      return {
        classificacao_financeira: this.abc_financeira,
        classificacao_criticidade: this.abc_criticidade,
        classificacao_comprabilidade: this.abc_comprabilidade,
        classificacao_popularidade: this.abc_popularidade,
        classificacao_rentabilidade: this.abc_rentabilidade
      }
    }
  },
  methods: {
    aplicarFiltros() {
      this.$emit('aplicar-filtros');
    }
  }
}
</script>
